import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

// Service
import { CostharegionInsertService } from '../../service/costharegion-insert/costharegion-insert.service';
import { StateListService } from '../../../state/service/state-list/state-list.service';
import { CityListService } from '../../../city/service/city-list/city-list.service';

@Component({
	selector: 'app-costharegion-insert',
	templateUrl: './costharegion-insert.component.html',
	providers: [
		CostharegionInsertService,
		StateListService,
		CityListService,
		HttpModule
	]
})

export class CostharegionInsertComponent implements OnInit {

	private token;
	public costForm: FormGroup;
	public Ativo: boolean;
	public permissoes: any[] = [];
	public states: any[] = [];
	public cities: any[] = [];

	constructor(private fb: FormBuilder, private router: Router, private costharegionInsertService: CostharegionInsertService, private stateListService: StateListService, private cityListService: CityListService, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');
		this.costForm = this.fb.group({
			'EstadoID':['', Validators.compose([Validators.required])],
			'CidadeID': ['', Validators.compose([Validators.required])],
			'ValorHaCultivavel': [null, Validators.compose([Validators.required])],
			'ValorHaNaoCultivavel': [null, Validators.compose([Validators.required])],
			'ModuloRural': [null, Validators.compose([Validators.required])],
			'Ativo': true
		});
	}

	ngOnInit() {
		this.getStates();
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	onEstadoChange(estadoID) {
		this.costForm.controls['CidadeID'].setValue('');
		if (estadoID != '') {
			this.getCities(estadoID);
		} else {
			this.cities = [];
		}
	}

	getCities(estadoID) {
		this.cityListService.getActiveCitiesByState(estadoID,this.token).subscribe(result => {
			this.cities = result.Result;
		}, error => {
			console.log(error);
		});
	}

	getStates() {
		this.stateListService.getActiveStates(this.token).subscribe(result => {
			this.states = result.Result;
		}, error => {
			console.log(error);
		});
	}

	addGroup(value: any) {
		this.costharegionInsertService.insertCost(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Custo Ha por Região cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/custo-regiao');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/custo-regiao');
	}

}



// WEBPACK FOOTER //
// ./src/app/costharegion/component/costharegion-insert/costharegion-insert.component.ts